import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Modal, Tabs, Tab } from 'Core/components';
import CustomPropTypes from 'Core/prop-types';
import { AppModal } from '../components/app-modals';
import { showToast } from 'Core/redux/toast/slice';
import EditOverheadCrane from './edit-overhead-crane';
import OverheadCraneDetailsForm from './overhead-crane-details-form';
import OverheadCraneMaintenanceHistory from './overhead-crane-maintenance-history';
import CellHistory from './cell-history';
import SafetyChecklist from './safety-checklist';
import SafetyChecklistHistory from './safety-checklist-history';

const saveKeys = ['changed', 'id', 'isDeleted', 'userId'];
const editKeys = ['changed', 'isDeleted'];

const OverheadCraneAddEdit = ({ showModal, modalData, onCloseModal }) => {
  console.log('OverheadCraneAddEdit -> modalData:', modalData);
  const overheadCraneData = modalData;
  const [formData, setFormData] = useState(overheadCraneData || null);
  const [cellData, setCellData] = useState(null);
  const [safetyData, setSafetyData] = useState(null);
  const [activeTabIndex, setActiveTabIndex] = useState(0);

  console.log('OverheadCraneAddEdit -> formData?.id:', formData?.id);
  console.log('OverheadCraneAddEdit -> formData?.overheadCraneId:', formData?.overheadCraneId);

  const dispatch = useDispatch();
  const isEditMode = Boolean(overheadCraneData?.id || overheadCraneData?.assetNumber);

  const onChangesOverheadCraneForm = data => {
    setFormData(data);
  };

  const onCellHistoryActionClick = (data, mode) => {
    setCellData({ data: data, mode: mode });
    setActiveTabIndex(1);
  };

  const onSafetyChecklistHistActionClick = (mode) => {
    setSafetyData({ mode: mode });
    setActiveTabIndex(3);
  };

  const handleTabChange = (newTabIndex) => {
    if (activeTabIndex === 1 && newTabIndex !== 1) {
      setCellData(null);
    }
    if (activeTabIndex === 5 && newTabIndex !== 5) {
      setSafetyData(null);
    }
    setActiveTabIndex(newTabIndex);
  };

  const handleClose = () => {
    onCloseModal();
  };

  const body = () => {
    return (
      <div className="row">
        {isEditMode && (
          <Tabs activeIndex={activeTabIndex} onTabChange={handleTabChange}>
            <Tab title="Edit Overhead Crane">
              <EditOverheadCrane
                data={formData}
                onChanges={onChangesOverheadCraneForm}
                onCloseModal={handleClose}
              />
            </Tab>
            <Tab title="Overhead Crane Maintenance Details">
              <OverheadCraneDetailsForm
                data={formData}
                isEditMode={true}
                cellActionRecord={cellData}
                onChanges={onChangesOverheadCraneForm}
                onCloseModal={handleClose}
              />
            </Tab>
            <Tab title="Maintenance Records History">
              <OverheadCraneMaintenanceHistory
                data={formData}
                overheadCraneId={formData?.overheadCraneId || formData?.id}
                onCloseModal={handleClose}
              />
            </Tab>
            <Tab title="Safety Checklist">
              <SafetyChecklist
                overheadCraneId={formData?.overheadCraneId || formData?.id}
                onCloseModal={handleClose}
              />
            </Tab>
            <Tab title="Cell History">
              <CellHistory
                assetNumber={formData?.assetNumber}
                onActionClick={onCellHistoryActionClick}
                onCloseModal={handleClose}
              />
            </Tab>
            <Tab title="Safety Checklist History">
              <SafetyChecklistHistory
                data={formData}
                onChanges={onChangesOverheadCraneForm}
                onCloseModal={handleClose}
                overheadCraneId={formData?.overheadCraneId || formData?.id}
                onActionClick={onSafetyChecklistHistActionClick}
              />
            </Tab>
          </Tabs>
        )}
        {!isEditMode && (
          <EditOverheadCrane
            data={formData}
            onChanges={onChangesOverheadCraneForm}
            onCloseModal={handleClose}
          />
        )}
      </div>
    );
  };

  const valid = () => {
    const ignoreKeys = isEditMode ? editKeys : saveKeys;
    if (
      !formData ||
      Object.keys(formData).some(key => {
        return !ignoreKeys.includes(key) && !formData[key];
      })
    ) {
      dispatch(
        showToast({
          message: 'Please fill all required fields',
          type: 'danger',
        }),
      );
      return false;
    }
    return true;
  };

  return (
    <Modal
      id="overhead-crane-modal"
      show={showModal}
      size="xl"
      title={isEditMode ? 'Overhead Crane Maintenance Summary' : 'Add Overhead Crane'}
      body={body}
      handleClose={handleClose}
    />
  );
};

OverheadCraneAddEdit.propTypes = {
  showModal: PropTypes.bool,
  modalData: PropTypes.shape(CustomPropTypes.Machines),
  onCloseModal: PropTypes.func,
};

export default AppModal(OverheadCraneAddEdit);
